export default __webpack_public_path__ + "static/media/speer_logo_footer.2d36bdb2.svg";